document.addEventListener('DOMContentLoaded', () => {
    const input = document.getElementById('autocomplete');
    const suggestionsDiv = document.getElementById('suggestions');

    if (input && suggestionsDiv) {
        // Use a debounce timer to avoid too many API calls
        let debounceTimeout;
        
        input.addEventListener('input', () => {
            const query = input.value.trim();
            
            if (debounceTimeout) clearTimeout(debounceTimeout);

            if (query === "") {
                suggestionsDiv.innerHTML = "";
                return;
            }
            
            debounceTimeout = setTimeout(() => {
                // Fetch suggestions from the autocomplete endpoint
                fetch(`/search/autocomplete/?query=${encodeURIComponent(query)}`)
                .then(response => response.json())
                .then(data => {
                    renderSuggestions(data.hits);
                })
                .catch(error => {
                    console.error('Error fetching autocomplete suggestions:', error);
                });
            }, 300);
        });
        
        function renderSuggestions(hits) {
            // If there are no suggestions, clear the container
            if (!hits || hits.length === 0) {
                suggestionsDiv.innerHTML = "";
                return;
            }
            
            // Build HTML for the suggestion list
            const buildHtml = hits => {
                return `
                <ul>
                    ${hits.map(hit => {
                    const imageTag = hit.image ? `<img src="${hit.image}" width="40" height="40" style="float:left; margin-right:10px;" />` : '';
                    return `
                        <li data-id="${hit.objectID}" data-title="${hit.title}">
                        ${imageTag}
                        <a href="${hit.url}">${hit.title}</a>
                        <br />
                        <p>${hit.excerpt}</p>
                        </li>
                    `;
                    }).join('')}
                </ul>
                `;
            };
            suggestionsDiv.innerHTML = buildHtml(hits);
            
            const suggestionItems = suggestionsDiv.querySelectorAll('li');
            suggestionItems.forEach(item => {
                item.addEventListener('click', function() {
                // Set the input value to the selected suggestion
                input.value = item.getAttribute('data-title');
                suggestionsDiv.innerHTML = "";
                });
            });
        }
        
        // Hide suggestions when clicking outside the input or suggestions box
        document.addEventListener('click', e => {
            if (e.target !== input) {
                suggestionsDiv.innerHTML = "";
            }
        });
    }
    

})
